<!-- Track and Untrack Sch L Modal Component -->
@if (showModal) {
<div class="modal-container track-untrack-modal" [class.minimized]="minimise">
  <!-- STANDARD Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{modalTitle}}</h3>
    <div class="header-actions">
      <i class="fa"  
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
         style="margin-right: 10px; cursor: pointer;"  
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- STANDARD Modal Body -->
  @if (!minimise) {
<div class="modal-body">
    <!-- FTR Notification Provided to IRS -->
    <div class="form-group">
      <label for="ftrNotification"><b>FTR Notification Provided to IRS:</b></label>
      <div class="dropdown-wrapper">
        <select 
          id="ftrNotification" 
          class="form-control" 
          [(ngModel)]="FTR_NOTIFICATION_PROVIDED"
          [disabled]="crudLoading">
          <option value="">Select...</option>
          @for (option of yesNoOptions; track $index) {
<option [value]="option.value">
            {{option.label}}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Conditional text input for FTR Notification -->
    @if (FTR_NOTIFICATION_PROVIDED === 'Yes') {
<div class="form-group">
      <label for="howNotification"><b>How:</b></label>
      <textarea 
        id="howNotification" 
        class="form-control" 
        [(ngModel)]="HOW_NOTIFICATION_PROVIDED"
        placeholder="Enter how notification was provided"
        [disabled]="crudLoading"
        rows="3"></textarea>
    </div>
}

    <!-- Adjustment Submitted to IRS -->
    <div class="form-group">
      <label for="adjustmentSubmitted"><b>Adjustment Submitted to IRS:</b></label>
      <div class="dropdown-wrapper">
        <select 
          id="adjustmentSubmitted" 
          class="form-control" 
          [(ngModel)]="ADJUSTMENT_SUBMITTED"
          [disabled]="crudLoading">
          <option value="">Select...</option>
          @for (option of yesNoOptions; track $index) {
<option [value]="option.value">
            {{option.label}}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Conditional text input for Adjustment Submitted -->
    @if (ADJUSTMENT_SUBMITTED === 'Yes') {
<div class="form-group">
      <label for="howAdjustment"><b>How:</b></label>
      <textarea 
        id="howAdjustment" 
        class="form-control" 
        [(ngModel)]="HOW_ADJUSTMENT_SUBMITTED"
        placeholder="Enter how adjustment was submitted"
        [disabled]="crudLoading"
        rows="3"></textarea>
    </div>
}
  </div>
}

  <!-- STANDARD Footer -->
  @if (!minimise) {
<div class="modal-footer-inline">
    <button class="save-button" 
            type="button" 
            (click)="save()" 
            [disabled]="isSaveClicked || crudLoading || (!FTR_NOTIFICATION_PROVIDED && !ADJUSTMENT_SUBMITTED)">
      @if (isSaveClicked || crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Submit
    </button>
    <button class="cancel-button" 
            type="button" 
            (click)="cancel()"
            [disabled]="crudLoading">
      Cancel
    </button>
  </div>
}
</div>
}

